// extracted by mini-css-extract-plugin
export default {"host":"Pagination_host__IGRdm"};